<template>
  <div
    class="bg-white flex flex-col divide-y divide-y-100 select-none"
    :class="[isCurrent ? '' : 'cursor-pointer hover:bg-gray-50']"
    @click="setCurrent"
  >
    <div class="flex">
      <div class="flex-1 px-4 py-4 text-sm text-gray-500 align-top">
        {{ datePeriod }}
      </div>
      <div class="px-4 py-4 text-sm text-gray-500 text-right">
        {{ subscriptionOrdersCount }} {{ subscriptionOrdersCount === 1 ? 'order' : 'orders' }}
      </div>
    </div>
    <div v-show="isCurrent" class="px-4 py-3 bg-gray-100 space-y-4">
      <ul class="border border-gray-200 rounded divide-y divide-gray-200 bg-white">
        <li
          v-for="subscriptionOrder in subscriptionOrders"
          :key="subscriptionOrder.uuid"
          class="hover:bg-gray-50 first:rounded-t last:rounded-b"
        >
          <RouterLink :to="getShowOrderRoute(subscriptionOrder.order)" class="px-4 py-3 block">
            {{ subscriptionOrder.order.name }}
          </RouterLink>
        </li>
      </ul>

      <AddSubscriptionOrderAction
        :period="period"
        :account-subscription-id="accountSubscription.uuid"
        nested
        @success="$emit('change')"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import AddSubscriptionOrderAction from './AddSubscriptionOrderAction.vue';

export default {
  components: {
    AddSubscriptionOrderAction,
  },
  props: {
    period: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      default: null,
    },
    accountSubscription: {
      type: Object,
      required: true,
    },
    subscriptionOrders: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    datePeriod() {
      const { dateStart, billingPeriod } = this.accountSubscription;
      return moment(dateStart).add(this.period, billingPeriod).format('MMMM YYYY');
    },
    subscriptionOrdersCount() {
      return this.subscriptionOrders.length;
    },
    isCurrent() {
      return this.value === this.period;
    },
  },
  methods: {
    setCurrent() {
      this.$emit('input', this.period);
    },
    getShowOrderRoute(order) {
      return {
        name: 'accounts.orders.show',
        params: {
          accountId: this.$route.params.accountId,
          orderId: order.uuid,
        },
      };
    },
  },
};
</script>
